import { Hydrate, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

import { FlagProviderWrapper } from 'lib/unleash';
import { Toaster } from 'react-hot-toast';
import '../public/css/tailwind-base.css';
import { isBrowser } from 'utils/isBrowser';
const isDev = process.env.NODE_ENV === 'development';

const persister = createSyncStoragePersister({
    storage: isBrowser ? window.localStorage : {},
});

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            cacheTime: 1000 * 60 * 60 * 24,
        },
    },
});

export default function App({ Component, pageProps }) {
    return (
        <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
            <Hydrate state={pageProps.dehydratedState}>
                <FlagProviderWrapper>
                    <Component {...pageProps} />
                    <Toaster />
                </FlagProviderWrapper>
            </Hydrate>
            {isDev && (
                <ReactQueryDevtools
                    initialIsOpen={false}
                    panelProps={{
                        style: { color: '#3a30ba' },
                    }}
                />
            )}
        </PersistQueryClientProvider>
    );
}
